// extracted by mini-css-extract-plugin
export default {"container":"listPlaceholder_container__Y+XIF"};